import styled from 'styled-components';
import ReactMarkDown from 'react-markdown';

export const MarkdownWrapper = styled(ReactMarkDown)`
  font-family: aktiv-grotesk, sans-serif;
  text-align: left;
  font-size: 1em;
  color: ${(props) => props.theme.black};
  line-height: 24px;
  margin-bottom: 20px;
`;
